import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../../../../services/api';
import { useMisc } from '../../../../contexts/MiscContext';
import { toast } from 'react-toastify';
import CookiesService from '../../../../services/cookies';
import AcompanhamentoMetasMain from './AcompanhamentoMetasMain';

const AcompanhamentoMetasContext = createContext();
export const useAcompanhamentoMetas = () => useContext(AcompanhamentoMetasContext);

export const AcompanhamentoMetasProvider = () => {
    const { setShowLoading } = useMisc();
    const userLogin = CookiesService.getUserLogin();

    const [showCad, setShowCad] = useState(false);
    const [mainData, setMainData] = useState([]);
    const [filterObj, setFilterObj] = useState({
        dataProgramacao: null,
        equipe: null,
    });
    const [listagem, setListagem] = useState({
        dataProgramacao: [],
        equipe: []
    });
    const [dataProgramacao, setDataProgramacao] = useState('');
    const [encarregado, setEncarregado] = useState('');
    const [meta, setMeta] = useState(0);
    const [showJustificativa, setShowJustificativa] = useState(false);
    const [justificativas, setJustificativas] = useState([]);
    const [observacao, setObservacao] = useState('');
    const [justificativaSelecionada, setJustificativaSelecionada] = useState(null);
    const [idDemandaSelecionada, setIdDemandaSelecionada] = useState(null);

    const handleOpenModalJustificativa = async (row) => {
        try {
            await buscarJustificativas();
            setIdDemandaSelecionada(row.IdDemanda);
            setShowJustificativa(true);
        } catch (error) {
            throw error('Erro ao abrir o modal de justificativa:', error);
        }
    };

    const buscarJustificativas = async () => {
        try {
            setShowLoading(true);
            const res = await api.get('/corte/controle-enfesto/acompanhamento-metas/get-metas-justificativas');
            setJustificativas(res.data.map((item) => ({
                value: item.id_justificativa,
                label: item.justificativa
            })));
        } catch (error) {
            toast.error('Erro ao buscar justificativas');
        } finally {
            setShowLoading(false);
        }
    }

    const handleCancel = () => {
        setShowCad(false);
        setDataProgramacao("");
        setEncarregado(null);
        setMeta(0);
    }

    function formatDate(inputDate, formatType) {
        if (!inputDate) return 'N/A';
        const date = new Date(inputDate);
        if (isNaN(date.getTime())) return 'N/A';
    
        const year = String(date.getUTCFullYear());
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');

        let formattedDate;

        formatType === 'value' ? formattedDate = `${year}-${month}-${day}` : formattedDate = `${day}/${month}/${year}`
    
        return formattedDate;
    }

    const fetchSelectorOptions = async () => {
        try {
            setShowLoading(true);
            const resDataProgramacao = await api.get('/corte/controle-enfesto/acompanhamento-metas/get-data-programacao-filtro');
            const resEquipes = await api.get('/corte/controle-enfesto/acompanhamento-metas/get-encarregados');
            setListagem({
                dataProgramacao: resDataProgramacao.data.map((item) => ({
                    value: formatDate(item.data_programacao, 'value'),
                    label: formatDate(item.data_programacao, 'label')
                })),
                equipe: resEquipes.data.map((item) => ({
                    value: item.ID_USUARIO,
                    label: item.NOME_COMPLETO
                })),

            });
        } catch (error) {
            toast.error('Erro ao buscar dados de DataProgramacao');
        } finally {
            setShowLoading(false);
        }
    }

    useEffect(() => {
        handleSearch();
        fetchSelectorOptions();
    }, [setShowLoading]);

    const handleShowCad = () => {
        setShowCad(true);
    }

    const handleSearch = async () => {
        try {
            setShowLoading(true);
            const params = {};
            if (filterObj.dataProgramacao) params.dataProgramacao = filterObj.dataProgramacao.value;
            if (filterObj.equipe) params.encarregado = filterObj.equipe.value;

            const response = await api.get('/corte/controle-enfesto/acompanhamento-metas/get-metas', { params });

            if (response.data.length === 0) {
                toast.warning('Não foram encontrados resultados.');
            } else {
                setMainData(response.data);
            }
        } catch (error) {
            toast.error('Ocorreu um erro ao buscar os dados da tela.');
        } finally {
            setShowLoading(false);
        }
    };

    const handleSetFilterObj = (key, value) => {
        setFilterObj(x => ({ ...x, [key]: value }));
    };

    const handleCancelMeta = async (idDemanda) => {
        try {
            setShowLoading(true);
    
            await api.patch(`/corte/controle-enfesto/acompanhamento-metas/delete/${idDemanda}`, { responsavel_inativacao: userLogin });
    
            setMainData((prevData) => prevData.filter((row) => row.IdDemanda !== idDemanda));
    
            toast.success('Meta cancelada com sucesso!');
        } catch (error) {
            toast.error('Erro ao cancelar a meta.');
        } finally {
            setShowLoading(false);
        }
    };

    return (
        <AcompanhamentoMetasContext.Provider value={{
            userLogin,
            showCad,
            setShowCad,
            handleShowCad,
            mainData,
            setMainData,
            handleSearch,
            filterObj,
            setFilterObj,
            handleSetFilterObj,
            listagem,
            setListagem,
            dataProgramacao,
            setDataProgramacao,
            encarregado,
            setEncarregado,
            meta,
            setMeta,
            handleCancel,
            showJustificativa,
            setShowJustificativa,
            justificativas,
            setJustificativas,
            observacao,
            setObservacao,
            justificativaSelecionada,
            setJustificativaSelecionada,
            handleOpenModalJustificativa,
            buscarJustificativas,
            idDemandaSelecionada,
            handleCancelMeta
        }}>
            <AcompanhamentoMetasMain />
        </AcompanhamentoMetasContext.Provider>
    )
};